import { orgDocChainForSubpath, splitOrgPath, withOrg } from "@/lib/appRoutes";
import { checkDocChain, type DocProbeResult } from "@/lib/legacyLinkResolution";

/**
 * Where the user should land after switching to `targetOrgId` while on the org
 * URL `pathname`. Sections carry over as-is; a trial/experiment/task page
 * carries over only if its whole document chain exists in the target org;
 * anything else, including a non-org path or a failed read, lands on the
 * target org's home. Search and hash never cross orgs: only a pathname comes in.
 */
export async function resolveOrgSwitchTarget(
  pathname: string,
  targetOrgId: string,
  probe: (relativeDocPath: string) => Promise<DocProbeResult>
): Promise<string> {
  const orgPath = splitOrgPath(pathname);
  const docChain = orgPath && orgDocChainForSubpath(orgPath.subpath);
  // A section's chain is empty, which matches without a lookup.
  if (docChain && (await checkDocChain(docChain, probe)) === "match") {
    return withOrg(targetOrgId, orgPath.subpath);
  }
  return withOrg(targetOrgId, "");
}
